module.exports = __webpack_public_path__ + "static/media/timeline-icon.aea2219d.svg";